import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import { getRestDayCountCopy, getShiftCountCopy } from 'modules/shift_management/lib/getDescription'
import getTransactionType, {
  TransactionTranslation,
} from 'modules/shift_management/lib/getTransactionType'

const getCopyModalTranslations = (shiftsCount: number, restDaysCount: number) => {
  const transactionType = getTransactionType(shiftsCount, restDaysCount)
  // TODO: Remove this flag once the restDays is released and use newDescription
  const restDayFlag = hasFeature('shift_management_rest_day')

  const and = i18n.t('shift_management.add_shift.and')

  const shiftsCounter = getShiftCountCopy(shiftsCount)
  const restDaysCounter = getRestDayCountCopy(restDaysCount)

  const shiftsString = `${shiftsCount} ${shiftsCounter}`
  const restDaysString = `${restDaysCount} ${restDaysCounter}`
  const bothString = `${shiftsString} ${and} ${restDaysString}`

  const body: TransactionTranslation = {
    shifts: shiftsString,
    'rest-days': restDaysString,
    both: bothString,
  }

  const defaultDescription = i18n.t('shift_management.copy_shift.description', {
    count: shiftsCount,
  })

  const newDescription = i18n.t('shift_management.copy_schedule.description', {
    count: body[transactionType],
  })

  return {
    description: restDayFlag ? newDescription : defaultDescription,
  }
}

export default getCopyModalTranslations
